import axios, { Method } from 'axios';
import { apis } from '../enviroments/enviroments';
import auth from '../auth/auth';

interface ApiServiceOptions {
  name: string;
  params?: any;
  queryParams?: any;
  body?: any;
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
  onFinally?: () => void;
  [key: string]: any
}

const apiService = async ({ name, params, queryParams, body, onSuccess, onError, onFinally, ...rest } : ApiServiceOptions) => {
  try {
    const actions = {
      login: async () => await auth.login(body),
      logout: async () => await auth.logout(),
      recovery: async () => await auth.recovery(body),
    };

    const action = name.toLowerCase();

    if (action in actions) {
      const response = await actions[action as keyof typeof actions]();

      onSuccess?.(response);
      return response;
    }

    const apiInfo = apis.find((API) => API.name === name);
    if (!apiInfo) {
      throw new Error(`No se encontraron variables de entorno para la API ${name}`);
    }

    let url = apiInfo.url;
    let auxUrl = url;
    if (params && Object.keys(params).length > 0) {
      let count = 0;
      while (auxUrl.indexOf('{') !== -1 && auxUrl.indexOf('}') !== -1 && count < 20) {
        const index = [auxUrl.indexOf('{'), auxUrl.indexOf('}')];
        if (params[auxUrl.substring(index[0] + 1, index[1])]) {
          url = url.toString().replace(auxUrl.substring(index[0], index[1] + 1), params[auxUrl.substring(index[0] + 1, index[1])]);
        } else {
          throw new Error(`-Faltan el parametro: ${auxUrl.substring(index[0] + 1, index[1])}`);
        }
        auxUrl = auxUrl.substring(auxUrl.indexOf('}') + 1, auxUrl.length);
        count++;
      }
    }

    if (queryParams && Object.keys(queryParams).length > 0) {
      const queryP = new URLSearchParams(queryParams).toString();
      url += `?${queryP}`;
    }

    const urlQuery = !!body && Object.keys(body).length > 0 ? new URL(url) : url
    if (body && Object.keys(body).length > 0 && (urlQuery instanceof  URL)) Object.keys(body).map(key => urlQuery.searchParams.append(key, body[key]))

    let headers: { [key: string]: string } = {
      'Content-Type': 'application/json',
    };
    if (apiInfo.headers) headers = apiInfo.headers;

    const user = rest.useSpecialToken ? localStorage.getItem('spUsInv') : localStorage.getItem('user');
    if (user) {
      const userData: any = JSON.parse(user);
      headers.Authorization = `Bearer ${userData.claims?._token}`;
    }

    const response = await axios({
      method: apiInfo.method as Method,
      url: url,
      headers,
      data: body,
      responseType: apiInfo?.responseType || 'json'
    });

    if (onSuccess) {
      onSuccess(response.data);
    }
    return response.data;    
  } catch (error) {
    if (axios.isAxiosError(error) && error.response && error.response.status === 401) {
      const user = localStorage.getItem('user');
      if (user) {
        const userData: any = JSON.parse(user);
        const expiryTimeStr = userData.claims?._fechaExpiracion;
        if (expiryTimeStr) {
          const [datePart, timePart, period] = expiryTimeStr.split(' ');
          const [day, month, year] = datePart.split('/').map(Number); // Asegurarse de que se lean como números
          let [hour, minute, second] = timePart.split(':').map(Number);

          // Ajuste de hora para AM/PM
          if (period.toLowerCase() === 'p. m.' && hour < 12) hour += 12;
          if (period.toLowerCase() === 'a. m.' && hour === 12) hour = 0;

          /// Crear fecha con valores correctos
          const expiryTime = new Date(year, month - 1, day, hour, minute, second).getTime();

          if (Date.now() > expiryTime) {
            await auth.logout();
            window.location.reload();
          }
        }
      } else {
        await auth.logout();
      }
    }

    if (onError) {
      const isObje = error !== null && typeof error === 'object';
      onError(isObje ? (error as { message: string }).message : JSON.stringify(error));
    }
    throw error;
  } finally {
    if (onFinally) {
      onFinally();
    }
  }
};

export default apiService;
